var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "fixedcontainer", staticClass: "container position-relative" },
    [
      _c("h3", { staticClass: "mb-24 mb-sm-80" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm.activity.acf.content.fixed_format.title) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _vm.activity.acf.content.fixed_format.time_table
        ? _c(
            "div",
            { staticClass: "fixed-format-row" },
            _vm._l(_vm.groupedFlatFormatArray, function(entryGroup, index) {
              return _c(
                "div",
                { staticClass: "fixed-format-timestamp-group" },
                [
                  _c(
                    "span",
                    { staticClass: "timestamp d-inline-block mb-16 mb-md-40" },
                    [_vm._v(_vm._s(entryGroup.timestamp))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex fixed-format-entry-row flex-wrap" },
                    _vm._l(entryGroup.entries, function(entry, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "fixed-format-entry",
                          class: {
                            "timepoint-wrapper":
                              index == 0 ||
                              entry.timestamp !=
                                _vm.flatFormatArray[index - 1].timestamp
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              tag: "component",
                              staticClass: "fixed-entry d-flex flex-column"
                            },
                            [
                              entry.type == "activity" &&
                              entry.data.acf.content.images
                                ? _c("img", {
                                    staticClass: "mb-16 mb-md-24",
                                    attrs: {
                                      src:
                                        entry.data.acf.content.images[0].sizes
                                          .medium_large,
                                      alt: ""
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              entry.type == "custom" && entry.data.image
                                ? _c("img", {
                                    staticClass: "mb-16 mb-md-24",
                                    attrs: {
                                      src: entry.data.image.sizes.medium_large,
                                      alt: ""
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              entry.type == "activity"
                                ? _c("h4", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(entry.data.post_title) +
                                        "\n                        "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              entry.type == "custom"
                                ? _c("h4", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(entry.data.title) +
                                        "\n                        "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              entry.type == "activity"
                                ? _c("div", {
                                    staticClass: "content",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        entry.data.acf.content.description
                                      )
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              entry.type == "custom"
                                ? _c("p", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(entry.data.description) +
                                        "\n                        "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              entry.type == "activity"
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-accent align-self-start mt-24",
                                      attrs: {
                                        href: _vm.route("nl.activity", {
                                          slug: entry.data.post_name
                                        })
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "Meer info\n                            "
                                      ),
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.svg(
                                              "arrow-right",
                                              "arrow-right"
                                            )
                                          )
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    }),
                    0
                  )
                ]
              )
            }),
            0
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }